<div class="container p-0">
    <form [formGroup]="companyForm" (ngSubmit)="upsertCompanyProfile()">
        <div class="main-body">
            <div class="row">
                <div class="col-lg-4">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex flex-column align-items-center text-center">
                                <div class="logo-container">
                                    <img [src]="company?.logo ? company?.logo: 'assets/images/avatar.png'" 
                                        alt="Admin" 
                                        class="logo-img">
                                  </div> 
                                <div class="mt-3">
                                    <h4 class="capitailized">{{company?.name}}</h4>
                                    <p class="text-secondary mb-1">
                                        {{company?.contact}}</p>
                                    <p class="text-mute font-size-sm">{{company?.website}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="card">
                        <div class="card-body">
                            <div class="row g-3">
                                <div class="col-md-4">
                                    <label for="name" class="form-label">Company Name <b
                                            class="text-secondary">*</b></label>
                                    <div class="input-group"> <span
                                            class="input-group-text bg-transparent border-end-0"><i
                                                class='bx bx-buildings'></i></span>
                                        <input type="text" class="form-control ps-1" id="name"
                                            placeholder="Enter company name"
                                            [ngClass]="{'is-invalid': submitted && f.name.errors}"
                                            formControlName="name" ngbAutofocus autocomplete="off" />
                                        <div class="invalid-feedback" *ngIf="submitted && f.name.errors">
                                            <span *ngIf="f.name.errors.required">Please provide a valid company
                                                name.</span>
                                            <span *ngIf="f.name.errors.pattern">Only letters are allowed.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label for="code" class="form-label">Code</label>
                                    <div class="input-group"> <span
                                            class="input-group-text bg-transparent border-end-0"><i
                                                class='bx bx-barcode-reader'></i></span>
                                        <input type="text" class="form-control ps-1" id="code"
                                            placeholder="Enter company code" readonly
                                            [value]="companyForm.value.code | uppercase"
                                            [ngClass]="{'is-invalid': submitted && f.code.errors}"
                                            formControlName="code" autocomplete="off" />
                                        <div class="invalid-feedback" *ngIf="submitted && f.code.errors">
                                            <span *ngIf="f.code.errors.required">Please provide a valid code.</span>
                                            <span *ngIf="f.code.errors.pattern">Only alphanumeric characters are
                                                allowed.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label for="contact" class="form-label">Contact Person<b
                                            class="text-secondary">*</b></label>
                                    <div class="input-group"> <span
                                            class="input-group-text bg-transparent border-end-0"><i
                                                class='bx bx-user-plus'></i></span>
                                        <input type="text" class="form-control ps-1" id="contact"
                                            placeholder="Enter contact person name"
                                            [ngClass]="{'is-invalid': submitted && f.contact.errors}"
                                            formControlName="contact" autocomplete="off" />
                                        <div class="invalid-feedback" *ngIf="submitted && f.contact.errors">
                                            <span *ngIf="f.contact.errors.required">Please provide a valid contact
                                                name.</span>
                                            <span *ngIf="f.contact.errors.pattern">Only alphanumeric characters are
                                                allowed.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label for="website" class="form-label">Website<b
                                            class="text-secondary">*</b></label>
                                    <div class="input-group"> <span
                                            class="input-group-text bg-transparent border-end-0"><i
                                                class='bx bx-globe'></i></span>
                                        <input type="text" class="form-control ps-1" id="website"
                                            placeholder="Enter website"
                                            [ngClass]="{'is-invalid': submitted && f.website.errors}"
                                            formControlName="website" autocomplete="off" />
                                        <div class="invalid-feedback" *ngIf="submitted && f.website.errors">
                                            <span *ngIf="f.website.errors.required">Please provide a valid
                                                website.</span>
                                            <span *ngIf="f.website.errors.pattern">Invalid website</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label for="domain" class="form-label">Domain</label>
                                    <div class="input-group"> <span
                                            class="input-group-text bg-transparent border-end-0"><i
                                                class='bx bx-server'></i></span>
                                        <input type="text" class="form-control ps-1" id="domain"
                                            placeholder="Enter domain name"
                                            [ngClass]="{'is-invalid': submitted && f.domain.errors}"
                                            formControlName="domain" autocomplete="off" />
                                        <div class="invalid-feedback" *ngIf="submitted && f.domain.errors">
                                            <span *ngIf="f.domain.errors.pattern">Invalid domain</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label for="gstIn" class="form-label">GST No</label>
                                    <div class="input-group"> <span
                                            class="input-group-text bg-transparent border-end-0"><i
                                                class='bx bx-barcode-reader'></i></span>
                                        <input type="text" class="form-control ps-1" id="gstIn"
                                            placeholder="Enter GST No"
                                            [ngClass]="{'is-invalid': submitted && f.gstIn.errors}"
                                            formControlName="gstIn" autocomplete="off"
                                            [value]="companyForm.value.gstIn | uppercase" validation="true" />
                                        <div class="invalid-feedback" *ngIf="submitted && f.gstIn.errors">
                                            <span *ngIf="f.gstIn.errors.pattern">Please provide a valid GST
                                                No.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label for="type" class="form-label">Account Period<b
                                            class="text-secondary">*</b></label>
                                    <div class="input-group">
                                        <span class="input-group-text bg-transparent border-end-0"><i
                                                class='bx bxs-grid-alt'></i></span>
                                        <ng-select class="form-control rcx-ng-select" formControlName="period"
                                            placeholder="Select account period"
                                            [ngClass]="{'is-invalid': submitted && f.period.errors}"
                                            [clearable]="false">
                                            <ng-option *ngFor=" let type of periodTypes;"
                                                [value]="type">{{type}}</ng-option>
                                        </ng-select>
                                        <div class="invalid-feedback" *ngIf="submitted && f.period.errors">
                                            <span *ngIf="f.period.errors.required">Please select a account
                                                period.</span>
                                            <span *ngIf="f.period.errors.pattern">Only letters are allowed.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label for="Logo" class="form-label">Logo</label>
                                    <div class="input-group">
                                        <input type="file" class="custom-file-input form-control" id="upload"
                                            (change)="getAndSetBase64($event)" accept=".jpg,.jpeg,.png">
                                    </div>
                                </div>
                                <h5 class="d-flex align-items-center">User Details</h5>
                                <div class="row g-3">
                                    <div class="col-md-6">
                                        <label for="username" class="form-label">Username</label>
                                        <div class="input-group">
                                            <span class="input-group-text bg-transparent border-end-0"><i
                                                    class='bx bx-user-plus'></i></span>
                                            <input type="text" class="form-control ps-1" [value]="session.name"
                                                id="username" placeholder="Enter your email" readonly>
                                        </div>
                                    </div>
                                    <div class="col-lg-auto ms-auto">
                                        <button type="submit" class="btn btn-secondary rcx-btn" #inProgress>
                                        <ng-container *ngIf="inProgress?.value == 'true'">
                                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            {{companyForm.value.id ? 'Updating...' : 'Saving...'}}
                                        </ng-container>
                                        <ng-container *ngIf="inProgress?.value != 'true'"> <i class="bx bx-save"></i>
                                            {{companyForm.value.id ? 'Update' : 'Save'}}
                                        </ng-container>
                                    </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>